import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LinkedinLearningCourses() {
  return <section data-section-id="259264" id="linkedin-learning-courses" className="relative w-full min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/linkedin_learning_banner.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/linkedin_learning_banner.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/linkedin_learning_banner.png-wvc-sizes" alt="David Linthicum LinkedIn Learning Courses" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950/90 to-teal-900/80"></div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-default font-bold text-white leading-tight mb-8 drop-shadow-lg">
            LinkedIn Learning
            <br />
            <span className="inline-block border-3 border-white rounded-md px-4 py-1 mt-2 md:mt-4">
              COURSES
            </span>
          </h1>

          <p className="text-lg md:text-xl font-sans text-white/90 mb-8 leading-relaxed max-w-2xl">
            David Linthicum has developed over 70 courses on LinkedIn Learning, many of which have been taken by hundreds of thousands of learners each year. These courses span cloud computing, cloud architecture, AI, AI architecture, and related enterprise technology topics. Explore the courses below and enroll directly on LinkedIn Learning.
          </p>

          <div className="flex flex-wrap items-center gap-4 mt-8">
            <Button asChild variant="outline" size="lg" className="bg-secondary text-secondary-foreground border-2 border-secondary hover:bg-secondary/90 rounded-md px-8 py-6 text-lg font-medium shadow-lg">
              <Link to="#course-listing">Explore Courses</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="bg-white/10 text-white border-2 border-white/30 hover:bg-white/20 backdrop-blur-sm rounded-md px-8 py-6 text-lg font-medium shadow-lg">
              <Link to="/ConnectPage">Get in Touch</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}